import { Reducer } from 'redux'
import { fromJS } from 'immutable'
import { IAboutLayout } from './../models'
import * as TYPES from './../actionTypes'

export const initialState: IAboutLayout = fromJS({
  loading: false,
  background: {
    url: '',
  },
  path: {},
  intro_section: {},
  middle_section: {},
  end_section: {},
  founders_section: {},
})

const aboutLayoutReducer: Reducer<IAboutLayout> = (state = initialState, action) => {
  switch (action.type) {
    case TYPES.SET:
      return state.merge(action.payload)
    case TYPES.CONTENT.TRIGGER:
      return state.set('loading', true)
    case TYPES.CONTENT.FAILURE:
      return state.set('error', action.payload)
    case TYPES.CONTENT.SUCCESS:
      return state.merge(action.payload)
    case TYPES.CONTENT.FULFILL:
      return state.set('loading', false)
    default:
      return state
  }
}

export default aboutLayoutReducer
